module.exports = __webpack_public_path__ + "static/media/Slide11.af7dca72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide11.png
// module id = 1633
// module chunks = 0